// ============================================================================
// CUSTOM FEATURED COLLECTION FUNCTIONALITY
// ============================================================================
// This file handles IntersectionObserver animations and parallax effects
// for product cards in the custom featured collection section.

(function() {
  'use strict';

  function initCustomFeaturedCollection() {
    var collectionContainer = document.querySelector('[data-collection-section-id]');
    if (!collectionContainer) return;

    var sectionId = collectionContainer.getAttribute('data-collection-section-id');
    var selector = '#collection-' + sectionId + ' .custom-product-card';
    var cards = document.querySelectorAll(selector);

    if (cards.length === 0) return;

    // ============================================================================
    // INTERSECTION OBSERVER - Fade-in animation on viewport
    // ============================================================================
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        var card = entry.target;
        if (entry.isIntersecting) {
          card.classList.add('in-view');
        } else {
          card.classList.remove('in-view');
        }
      });
    }, { threshold: 0.2 });

    cards.forEach(function(card) {
      observer.observe(card);
    });

    // ============================================================================
    // PARALLAX-STYLE ZOOM EFFECT
    // ============================================================================
    var wrapperSelector = '#collection-' + sectionId + ' .custom-product-card__image-wrapper';
    var wrappers = document.querySelectorAll(wrapperSelector);

    function getImageElement(wrapper) {
      return wrapper.querySelector('.custom-product-card__image--primary') || wrapper.querySelector('.custom-product-card__image');
    }

    wrappers.forEach(function(wrapper) {
      wrapper.addEventListener('mousemove', function(e) {
        var img = getImageElement(wrapper);
        if (!img) return;

        var rect = wrapper.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - 0.5;
        var y = (e.clientY - rect.top) / rect.height - 0.5;
        img.style.transform = 'scale(1.1) translate(' + (x * 15) + 'px, ' + (y * 15) + 'px)';
      });

      wrapper.addEventListener('mouseleave', function() {
        var img = getImageElement(wrapper);
        if (img) {
          img.style.transform = 'scale(1)';
        }
      });
    });
  }

  // ============================================================================
  // INITIALIZATION
  // ============================================================================
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomFeaturedCollection);
  } else {
    initCustomFeaturedCollection();
  }

})();
